import React, { Component  } from 'react';

class InputForm2 extends Component{
    constructor(props){
        super(props)
    }

    render(){
        return(
            <div className="input-form form-group row">
                <label className="col-sm-2 col-form-label">{this.props.label}<br/><b>{this.props.label2}</b></label>
                <div className="col-sm-10">

                    <input 
                        className="form-control" 
                        ref={this.props.ref}
                        name={this.props.name} 
                        value={this.props.value} 
                        onChange={this.props.onChange} 
                        type={this.props.type} 
                        checked={this.props.checked}
                        placeholder={this.props.placeholder}
                        />

                    <label 
                        className="form-error">
                        {this.props.error.join(", ")} 
                        </label>   
                </div>
            </div>)
    }
}

export default InputForm2;